// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"293":"9118e726","678":"898cd9d3"}[chunkId] + ".css";
};